import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap"

import { useDispatch } from "react-redux"
import { deleteUserAccount } from "store/actions"

// i18n
import { withTranslation } from "react-i18next"

// Redux
import { useHistory, withRouter } from "react-router-dom"

// images
import { FcManager } from "react-icons/fc"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const dispatch = useDispatch()
  const history = useHistory()
  const Role = localStorage.getItem("role")

  const handleLogout = async () => {
    localStorage.clear()
    window.location.reload()
  }

  const toggleDeleteModal = () => {
    setShowDeleteModal(!showDeleteModal)
  }

  const confirmDeleteAccount = () => {
    dispatch(deleteUserAccount({ history }))
    window.location.reload()
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="rounded-circle header-profile-user">
            <FcManager size={"1.6rem"} />
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <span
            className="dropdown-item"
            style={{ cursor: "pointer" }}
            onClick={handleLogout}
          >
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </span>
          {Role === "student" && (
          <span
            className="dropdown-item"
            style={{ cursor: "pointer" }}
            onClick={toggleDeleteModal}
          >
            <i className="bx bx-trash font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Delete Account")}</span>
          </span>
          )}
        </DropdownMenu>
      </Dropdown>

      {/* Delete Account Confirmation Modal */}
      <Modal isOpen={showDeleteModal} toggle={toggleDeleteModal} centered>
        <ModalHeader toggle={toggleDeleteModal}>
          {props.t("Confirm Deletion")}
        </ModalHeader>
        <ModalBody>
          {props.t(
            "Are you sure you want to delete your account?"
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleDeleteModal}>
            {props.t("Cancel")}
          </Button>
          <Button color="danger" onClick={confirmDeleteAccount}>
            {props.t("Delete")}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(ProfileMenu))
